const state = {
    itens: [],
    item: {
        id: null,
        name: '',
        module_id: '',
        module: {
            id: null,
            name: '',
            icon: ''
        }
    }
};

export default state;